module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABcAAAAjCAYAAAB/wZEbAAABM0lEQVRIie2WsU7DMBCGv0DfoIQHYKRru8HQFakvQroiHiQFwRPQlaljh7DRNWw8QdhZkMKQMzqCiR0rlkDqSZadu/P3S1b+OMl4WhbAGcPH00EEqIlkBJxHo9d1/SN5NHsJgr09n357jnksveAp8CEjHRKeAlvgUMbWR8AHbsATlZv4CLjgGlyqfOkj4IJvFHiu8nMlsAmFvwM7gVUqX0luJz3WGDngXQargFnX5qjvudWh7VCONc1J2422+DMO3cP38P8K73uHfjnUVux7h14Ai476Qnqs4YI/AI/ApaWWSW0dCr+WedUSyIBc1le/bXZ9z+9oLuRcBF5pztuAl8B9KBzgRuYcOFH5JXDbtdEHrgVWMmcucB+4ETiWtRMMkIynpbsrMKLbv6Bx3tCjiPrz/wlvllUc8A6STwAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./static/images/icon/icon-height.png
// module id = sIFT
// module chunks = 1